import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export interface Props {
  color?: string
  backgroundColor?: string
  onClick?: () => void
  label: string
  testId?: string
  icon?: IconDefinition
}

interface StyledPillProps {
  $color: string
  $backgroundColor: string
  $clickable: boolean
}

const StyledPill = styled.div<StyledPillProps>`
  display: inline-block;
  gap: 1em;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 50px;
  padding: 7px 15px 9px;
  margin-right: 10px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  span {
    color: ${({ $color }) => $color};
    text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
  }

  .info-icon {
    margin-left: 7px;
  }
`

export const HeaderPill = ({
  label,
  testId,
  onClick,
  color = '#fff',
  backgroundColor = '#111',
}: Props) => {
  const hasClickHandler = onClick !== undefined
  return (
    <StyledPill
      data-testid={testId}
      $color={color}
      $backgroundColor={backgroundColor}
      $clickable={hasClickHandler}
      onClick={onClick}
    >
      <span>{label}</span>
      {hasClickHandler && (
        <FontAwesomeIcon
          color={color}
          icon={faInfoCircle}
          size="1x"
          data-testid="icon"
          className="info-icon"
        />
      )}
    </StyledPill>
  )
}
